module.exports = __webpack_public_path__ + "1028de9ffc5c6af54eb675524639a844.png";